import { MouseEventHandler } from 'react';
import { Button } from 'antd';
import classNames from 'classnames';

import './LinkLikeButton.less';

const LinkLikeButton = ({
  children,
  onClick,
  dataTestId,
  color = 'blue',
  disabled = false,
  className,
}: {
  children: React.JSX.Element | string;
  onClick: MouseEventHandler<HTMLElement>;
  dataTestId?: string;
  color?: string;
  disabled?: boolean;
  className?: string;
}) => (
  <Button
    disabled={disabled}
    type="text"
    onClick={onClick}
    className={classNames('__LinkLikeButton__', color, { disabled }, className)}
    data-testid={dataTestId}
  >
    {children}
  </Button>
);

export default LinkLikeButton;
